import React from 'react'

const RedirectSvg = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className='redirect redirect-icon'>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 5C16 4.44772 16.4477 4 17 4H26C27.1046 4 28 4.89543 28 6V15C28 15.5523 27.5523 16 27 16C26.4477 16 26 15.5523 26 15V7.41438L14.7074 18.7073C14.3169 19.0978 13.6837 19.0978 13.2932 18.7073C12.9027 18.3168 12.9027 17.6836 13.2932 17.2931L24.586 6H17C16.4477 6 16 5.55228 16 5ZM4 8C4 6.89543 4.89543 6 6 6H9C9.55229 6 10 6.44772 10 7C10 7.55229 9.55229 8 9 8H6V26H24V23C24 22.4477 24.4477 22 25 22C25.5523 22 26 22.4477 26 23V26C26 27.1046 25.1046 28 24 28H6C4.89543 28 4 27.1046 4 26V8Z" fill="currentColor" />
        </svg>
    )
}
export default RedirectSvg;